import React, { useEffect, useState } from 'react'
import { Col, Row, Input, Form, Button, Select, Spin } from 'antd'
import commonStyles from '../../../Utils/Common.less'
import { SaveOutlined } from '@ant-design/icons'
import { connect, useDispatch } from 'react-redux'
import {
    GetServiceProcessReviewDetails,
    SaveChangePrgress,
    SetReview,
} from '../../../Services/ToDoViewAllList'
import {
    type ClientReviewPeriod,
    defaultClientReviewPeriod,
    type ServiceProcessReviewPayload,
} from '../../../Types/ToDoViewAllList'
import { FORMAT_DATE } from '../../../Utils/dateFormat'
import { GetUserList } from '../../../Services/User'
import { GetServiceUserList } from '../../../Services/ServiceSetup'
import { type ServiceUserListType } from '../../../Types/ServiceSetup/ServiveUser'

interface holdthisMolde extends ServiceProcessReviewPayload {
    changeModelState: () => void
    serviceProcessId: number
    resetData: string
    setResetData: React.Dispatch<React.SetStateAction<string>>
    reviewerId: number
    businessTypeId: number
    serviceActionId: number
    assignedToBeforeReview: string
    assignedDateBeforeReview: string
    typeId: number
    referenceId: number
}
const RequestApproval = (props: holdthisMolde): React.ReactElement => {
    const {
        changeModelState,
        serviceProcessId,
        userList,
        resetData,
        setResetData,
        reviewerId,
        businessTypeId,
        serviceActionId,
        assignedToBeforeReview,
        assignedDateBeforeReview,
        typeId,
        serviceUserList,
        referenceId,
    } = props
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const [buttonLoading, setButtonloading] = useState(false)
    const [reviewDetails, setReviewDetails] = useState<ClientReviewPeriod>(
        defaultClientReviewPeriod
    )
    const user = localStorage.getItem('user')
    const userDetials = user !== null ? JSON.parse(user).userId : ''
    const [pageLoading, setPageLoading] = useState(false)
    useEffect(() => {
        return () => {
            GetUserList(dispatch)
            GetServiceUserList(dispatch)
        }
    }, [])
    useEffect(() => {
        if (resetData === 'true') {
            form.resetFields()
        }
        setResetData('false')
    }, [resetData])

    const serviceData = serviceUserList?.find((item) => item?.serviceId === 10)
    let uniqueUserList: ServiceUserListType[] = []
    if (serviceData !== undefined) {
        const mergedUsersMap = new Map<number, ServiceUserListType>()

        ;[
            ...serviceData?.defaultAssigneeUser,
            ...serviceData?.defaultUser,
        ].forEach((user) => {
            if (!mergedUsersMap.has(user?.userId)) {
                mergedUsersMap.set(user?.userId, user)
            }
        })

        uniqueUserList = Array.from(mergedUsersMap.values())
    }

    const findAssignId = userList?.find((userObj) => {
        return userObj?.label === assignedToBeforeReview
    })
    useEffect(() => {
        const timer = setTimeout(() => {
            const fetchReviewDetails = async (): Promise<void> => {
                try {
                    setPageLoading(true)
                    const response = await GetServiceProcessReviewDetails(
                        dispatch,
                        serviceProcessId,
                        10
                    )
                    if (response !== null && response !== undefined) {
                        setPageLoading(false)
                        setReviewDetails(response)
                    }
                } catch (error) {
                    console.error('Error fetching review details:', error)
                }
            }
            void fetchReviewDetails()
        }, 300)

        return () => {
            clearTimeout(timer)
        }
    }, [serviceProcessId])

    const callBackActionApi = async (): Promise<void> => {
        const dataToSave = {
            type: typeId,
            referenceId: serviceActionId ?? 0,
            statusId: 3,
            remarks: '',
            completeFlag: 1,
            serviceProcessId,
            emailTemplateId: 0,
            serviceProcessStatusProperty: [],
        }
        await SaveChangePrgress(dispatch, dataToSave)
    }
    const onSave = (): void => {
        void onSavePhone()
    }
    const onSavePhone = async (): Promise<void> => {
        try {
            await form.validateFields()
            setButtonloading(true)
            const formData = form.getFieldsValue()

            const dataTosave = {
                serviceProcessId,
                serviceId: 10,
                reviewerUserId: formData.reviewerUserId,
                reviewerStatus: 11,
                reviewComments: formData.description,
                type: businessTypeId,
                referenceId,
                dueDate: FORMAT_DATE(reviewDetails?.periodEndDate),
                assignedToBeforeReview: findAssignId?.value ?? 0,
                assignedDateBeforeReview: FORMAT_DATE(assignedDateBeforeReview),
            }

            await SetReview(dispatch, dataTosave)
                .then((result) => {
                    if (result !== null && result !== undefined) {
                        form.resetFields()

                        void callBackActionApi()

                        setTimeout(() => {
                            changeModelState()
                            setButtonloading(false)
                        }, 2000)
                    }
                })
                .catch(() => {})
        } catch (error) {}
    }

    const onSave2 = (): void => {
        void onSavePhone2()
    }

    const onSavePhone2 = async (): Promise<void> => {
        try {
            setButtonloading(true)

            const dataTosave = {
                serviceProcessId,
                serviceId: 10,
                reviewerUserId: reviewerId,
                reviewerStatus: 12,
                reviewComments: reviewDetails?.reviewComments ?? '',
                type: businessTypeId,
                referenceId,
                dueDate: FORMAT_DATE(reviewDetails?.periodEndDate),
                assignedToBeforeReview: findAssignId?.value ?? 0,
                assignedDateBeforeReview: FORMAT_DATE(assignedDateBeforeReview),
            }

            await SetReview(dispatch, dataTosave)
                .then((result) => {
                    if (result !== null && result !== undefined) {
                        form.resetFields()

                        void callBackActionApi()

                        setTimeout(() => {
                            changeModelState()
                            setButtonloading(false)
                        }, 2000)
                    }
                })
                .catch(() => {})
        } catch (error) {}
    }

    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commonStyles.requireIcon}>*</span>}
        </>
    )

    return (
        <>
            <Spin spinning={pageLoading} tip="Loading..." size="large">
                <div style={{ lineHeight: '0.2' }}>
                    <h3>{reviewDetails?.clientBusinessName}</h3>
                    <h5>
                        CS Process for the Period of{' '}
                        {FORMAT_DATE(reviewDetails?.periodStartDate)} to{' '}
                        {FORMAT_DATE(reviewDetails?.periodEndDate)}
                    </h5>
                </div>
                <div className={commonStyles.formWrapper}>
                    <Form
                        name="complex-form"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        initialValues={{ remember: true }}
                        layout={'vertical'}
                        autoComplete="off"
                        form={form}
                        requiredMark={customizeRequiredMark}
                    >
                        {reviewerId === userDetials ? (
                            <>
                                <Row gutter={16}>
                                    <div
                                        style={{
                                            fontSize: '14px',
                                            fontWeight: 700,
                                            marginLeft: 20,
                                        }}
                                    >
                                        Comments to the Reviewer
                                    </div>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <span
                                            style={{
                                                marginLeft: 25,
                                            }}
                                        >
                                            {reviewDetails?.reviewComments}
                                        </span>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col offset={20} span={2}>
                                        <Button
                                            type="primary"
                                            size="middle"
                                            loading={buttonLoading}
                                            onClick={onSave2}
                                        >
                                            Approve
                                        </Button>
                                    </Col>
                                </Row>
                            </>
                        ) : (
                            <>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Form.Item
                                            label="Reviewer"
                                            name="reviewerUserId"
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        'Please Select Reviewer Id!',
                                                },
                                            ]}
                                        >
                                            <Select
                                                size="middle"
                                                allowClear
                                                placeholder="Please select"
                                                onChange={() => {}}
                                                showSearch
                                            >
                                                {' '}
                                                {uniqueUserList.map((user) => (
                                                    <Select.Option
                                                        key={user.userId}
                                                        value={user.userId}
                                                        label={user.userName}
                                                    >
                                                        {user.userName}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <Form.Item
                                            label="Comments to the Reviewer"
                                            name="description"
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        'Please input your Comments!',
                                                },
                                            ]}
                                        >
                                            <Input.TextArea rows={4} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col offset={21} span={2}>
                                        <Button
                                            type="primary"
                                            size="middle"
                                            onClick={onSave}
                                            loading={buttonLoading}
                                        >
                                            <SaveOutlined />
                                        </Button>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </Form>
                </div>
            </Spin>
        </>
    )
}
const mapStateToProps = (state: any): ServiceProcessReviewPayload => {
    return {
        userList: state.user.userList,
        serviceUserList: state.serviceSetup.serviceUserList,
    }
}

export default connect(mapStateToProps)(RequestApproval)
